import { QuestionMarkTooltip } from '../../../report-shared/components';
import { CallPill } from './CallPill';

// Rendered into the report header's General Info column, below Line of Business
// (BAL-8313). Lives here rather than in the shared HeaderSection so the header
// stays free of ENDS-specific vocabulary.
export const MysteryShopperCallHeaderField = ({ callStatus }: { callStatus?: string | null }) => (
  <div className="mt-4">
    <div className="mb-3 flex items-center gap-1">
      <h4 className="text-sm font-semibold text-stone-400">MYSTERY SHOPPER CALL</h4>
      <QuestionMarkTooltip
        text="Status of the compliance call placed to this merchant by a shopper posing as a customer."
        className="ml-2"
      />
    </div>
    <CallPill value={callStatus} />
  </div>
);
